export interface SitecoreLookupId {
  id: string;
  type: string;
  name: string;
}

export const parseSCLookupValue = (lookupValue: string): SitecoreLookupId => {
  const [id, type, name] = lookupValue.split(':');
  if (![id, type, name].every(Boolean)) {
    throw 'cannot parse lookup value ' + lookupValue;
  }
  return { id, type, name };
};

export const parseSCLookupValueList = (lookupValueList?: string): SitecoreLookupId[] => {
  if (!lookupValueList) return [];
  const values = lookupValueList.split('|');
  return values.map((lookupValue) => parseSCLookupValue(lookupValue));
};

export const parseSCId = (sitecoreID?: string): string =>
  sitecoreID ? sitecoreID.replaceAll(/[{}]/gi, '') : '';
